import { first } from 'rxjs/operators';
//import { GuestRefundService, GuestRefund } from '@app/_components/guestRefund';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
//import { GuestRefundComponent } from '../guestRefund/guestRefund.component';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { GuestRefund } from '../guest-refund';
import { GuestRefundComponent } from '../guest-refund/guest-refund.component';
import { GuestRefundService } from '../guest-refund.service';

@Component({
    selector: 'app-guest-refund-list',
    templateUrl: './guest-refund-list.component.html',
    styleUrls: ['./guest-refund-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class GuestRefundListComponent implements OnInit {
	total: any;
	constructor(
    private guestRefundService: GuestRefundService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
    private dialog: MatDialog,
	) {
    this.statuses = guestRefundService.statuses
	}

  private formatToYyyyMmDd(date: Date): string {
    if (!date) return null;
    const yyyy = date.getFullYear();
    const mm = (date.getMonth() + 1).toString().padStart(2, '0');
    const dd = date.getDate().toString().padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  onDateFilterChange(field: string, date: Date, table: any) {
    const formatted = this.formatToYyyyMmDd(date);
    table.filter(formatted || null, field, 'in');
  }

	// data
  @Input() reservationId: any;
  @Input() showFilter = true;
	guestRefunds: any;
	guestRefund: GuestRefund;
	showPaginator = false;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}

		this.setupColumns();
	}

	setupColumns() {
		this.columns = [
			// { field: 'guestRefundId', header: 'Id', width: 'auto' },
			{ field: 'lastName', header: 'Name', width: 'auto', condition: true,sorting: true },
			{ field: 'reservationVO.shortTermRentalVO.shortTermRentalId', header: 'ShortTermRentalId', width: 'auto', condition: !this.reservationId,sorting: true },
			{ field: 'reservationVO.shortTermRentalVO.propertyCode', header: 'Property', width: 'auto', condition: true,sorting: true },
			{ field: 'status', header: 'Status', width: 'auto', condition: true,sorting: false },
			{ field: 'refundAmountTTL', header: 'Refund $', width: 'auto', condition: true,sorting: true },
			{ field: 'checkInDate', header: 'Check In', width: 'auto', condition: true,sorting: true },
			{ field: 'checkOutDate', header: 'check Out', width: 'auto', condition: true,sorting: true },
			{ field: 'submittedDate', header: 'Submitted', width: 'auto', condition: true,sorting: true	 },
			{ field: 'creditAuthSendDate', header: 'Credit Auth Send Date', width: 'auto', condition: !this.reservationId,sorting: true },
			{ field: 'creditAuthRcvDate', header: 'Credit Auth Rcv Date', width: 'auto', condition: !this.reservationId,sorting: true },
			{ field: 'acctRcvDate', header: 'Acct Rcv Date', width: 'auto', condition: !this.reservationId,sorting: true },
			{ field: 'acctProcessDate', header: 'Acct Process Date', width: 'auto', condition: !this.reservationId,sorting: true },
			{ field: 'guestRcvFundsEstDate', header: 'Guest Rcv Funds Est Date', width: 'auto', condition: !this.reservationId,sorting: true },
		];
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.guestRefundId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-guestRefund-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}
			
			if (this.reservationId) {
				// show only reservations that are assigned to this reservationId
				let reservationIdFilter = { 'reservationVO.reservationId': { 'value': this.reservationId, 'matchMode': 'in' } };
				Object.assign(event.filters, reservationIdFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.guestRefundService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.guestRefunds = res.data.guestRefunds;
						this.getTotalOfAllRefundAmount();
						if(this.guestRefunds.length < event.rows){
							this.showPaginator = false;
						}else{
							this.showPaginator = true;
						}
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.guestRefunds = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(guestRefund: GuestRefund) {
		try {
			this.formLoading = true;
			this.guestRefundService.update(guestRefund)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.guestRefunds.map((guestRefund, i) => {
							if (guestRefund.guestRefundId === res.data.guestRefund.guestRefundId) {
								this.guestRefunds[i] = res.data.guestRefund;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(guestRefund: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(guestRefund));

			this.formLoading = true;
			this.guestRefundService.delete(guestRefund.guestRefundId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.guestRefunds.splice(this.guestRefunds.indexOf(guestRefund), 1);
						this.recordTotal = this.guestRefunds.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'GuestRefund ' + guestRefund.guestRefundId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'GuestRefund ' + guestRefund.guestRefundId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.width = '80%';

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Credit Authorization Acknowledgement',
			guestRefund: {
				reservationId: this.reservationId
			},
			reservationId: this.reservationId
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(GuestRefundComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addGuestRefundCB(data);

				// close the dialogBox
				//dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(guestRefund: GuestRefund) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.width = '80%';

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			guestRefund: guestRefund,
			title: 'Edit Credit Authorization Acknowledgement'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(GuestRefundComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateGuestRefundCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteGuestRefundCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addGuestRefundCB(guestRefund: GuestRefund) {
		console.log('Adding GuestRefund: ' + JSON.stringify(guestRefund));
		// Reload from the server so the grid shows fully-populated data (joined fields
		// like propertyCode and computed refundAmountTTL that the POST response may omit).
		if (this.lazyLoadEvent) {
			this.loadLazy(this.lazyLoadEvent);
		} else {
			// Fallback: patch local array when lazyLoadEvent is not yet available
			if (!this.guestRefunds) {
				this.guestRefunds = [];
			}
			this.guestRefunds.unshift(guestRefund);
			this.guestRefunds = [...this.guestRefunds];
			this.getTotalOfAllRefundAmount();
		}
		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'GuestRefund ' + guestRefund.guestRefundId + ' Added', life: 3000 });
	}

	updateGuestRefundCB(guestRefund: GuestRefund) {
		console.log('Updating GuestRefund: ' + JSON.stringify(guestRefund));
		// Reload from server so join fields (propertyCode etc.) stay in sync
		if (this.lazyLoadEvent) {
			this.loadLazy(this.lazyLoadEvent);
		} else {
			let itemIndex = this.guestRefunds.findIndex((item: any) => item.guestRefundId === guestRefund.guestRefundId);
			this.guestRefunds[itemIndex] = guestRefund;
			this.guestRefunds = [...this.guestRefunds];
			this.getTotalOfAllRefundAmount();
		}
		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'GuestRefund ' + guestRefund.guestRefundId + ' Updated', life: 3000 });
	}

	deleteGuestRefundCB(guestRefund: GuestRefund) {
		console.log('Removing GuestRefund: ' + guestRefund);
		this.guestRefunds.splice(this.guestRefunds.indexOf(guestRefund), 1);
		this.recordTotal = this.guestRefunds.length;

		// no idea what this is but it is required to update the array
		this.guestRefunds = [...this.guestRefunds];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'GuestRefund ' + guestRefund.guestRefundId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.guestRefunds ? this.first === (this.guestRefunds.length - this.rows) : true; }
	isFirstPage(): boolean { return this.guestRefunds ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(guestRefund: any) {
		if (guestRefund?.status) {
			const status = this.statuses.find((e: any) => e.value == guestRefund.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}

	getTotalRefundAmount(guestRefund: any){
		if(!guestRefund?.guestRefundReasons || guestRefund?.guestRefundReasons.length == 0){
			return 0;
		}
		let total = 0;
		guestRefund?.guestRefundReasons.forEach((refundReason) => {
			total += refundReason.refundAmount ? refundReason.refundAmount : 0;
		 });
		 return total;
	}

	getTotalOfAllRefundAmount() {
		this.total = 0;
		if (!this.guestRefunds || this.guestRefunds.length == 0) {
			return 0;
		}
		this.guestRefunds.forEach((guestRefund) => {
			this.total += guestRefund.refundAmountTTL != null ? guestRefund.refundAmountTTL : 0;
		});
		return this.total;
	}
}
